exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type='radio'][data-v-5d9d9306]:checked:after {\n  width: 10px;\n  height: 10px;\n  border-radius: 15px;\n  position: relative;\n  background-color: #de1a23;\n  content: '';\n  display: inline-block;\n  visibility: visible;\n  border: 2px solid white;\n}\ninput[type='radio'][data-v-5d9d9306] {\n  cursor: pointer;\n}\n", ""]);

// exports
